// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.email-body ol {
  list-style-type: decimal;
  padding-left: 1.5rem;
}

.email-body ul {
  list-style-type: disc;
  padding-left: 1.5rem;
}


/* TipTap spacing fix */
.ProseMirror {
  padding: 8px;
}

.ProseMirror p {
  margin: 0;
}

/* .ProseMirror img {
  margin-bottom: 8px;
} */

.ProseMirror ul,
.ProseMirror ol {
  margin: 0;
  padding-left: 1.25rem;
}

.ProseMirror li {
  margin: 0;
}

.ProseMirror h1,
.ProseMirror h2,
.ProseMirror h3 {
  margin: 0.25rem 0;
}


[data-resize-handle] {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #0d6efd; /* Blue handle color */
  border: 2px solid white;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
}

/* Position handles for corners/edges (Tiptap applies these data attributes) */
[data-resize-handle="top-left"] { top: -5px; left: -5px; cursor: nwse-resize; }
[data-resize-handle="top-right"] { top: -5px; right: -5px; cursor: nesw-resize; }
[data-resize-handle="bottom-left"] { bottom: -5px; left: -5px; cursor: nesw-resize; }
[data-resize-handle="bottom-right"] { bottom: -5px; right: -5px; cursor: nwse-resize; }
[data-resize-handle="left"] { left: -5px; top: 50%; transform: translateY(-50%); cursor: ew-resize; width: 10px; height: 20px; }
[data-resize-handle="right"] { right: -5px; top: 50%; transform: translateY(-50%); cursor: ew-resize; width: 10px; height: 20px; }
[data-resize-handle="top"] { top: -5px; left: 50%; transform: translateX(-50%); cursor: ns-resize; width: 20px; height: 10px; }
[data-resize-handle="bottom"] { bottom: -5px; left: 50%; transform: translateX(-50%); cursor: ns-resize; width: 20px; height: 10px; }

/* Optional: Style during active resize */
.is-resizing {
  opacity: 0.8;
  cursor: grabbing;
}

/* Ensure the resizable container doesn't interfere */
.tiptap-resizable {
  position: relative;
  display: inline-block;
}


`, "",{"version":3,"sources":["webpack://./src/components/emailBody.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;;AAGA,uBAAuB;AACvB;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;;GAEG;;AAEH;;EAEE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAGE,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,sBAAsB;EACjD,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,8EAA8E;AAC9E,kCAAkC,SAAS,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAC9E,mCAAmC,SAAS,EAAE,WAAW,EAAE,mBAAmB,EAAE;AAChF,qCAAqC,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACpF,sCAAsC,YAAY,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACtF,8BAA8B,UAAU,EAAE,QAAQ,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY,EAAE;AAC/H,+BAA+B,WAAW,EAAE,QAAQ,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY,EAAE;AACjI,6BAA6B,SAAS,EAAE,SAAS,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY,EAAE;AAC9H,gCAAgC,YAAY,EAAE,SAAS,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,WAAW,EAAE,YAAY,EAAE;;AAEpI,yCAAyC;AACzC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":["\n.email-body ol {\n  list-style-type: decimal;\n  padding-left: 1.5rem;\n}\n\n.email-body ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n}\n\n\n/* TipTap spacing fix */\n.ProseMirror {\n  padding: 8px;\n}\n\n.ProseMirror p {\n  margin: 0;\n}\n\n/* .ProseMirror img {\n  margin-bottom: 8px;\n} */\n\n.ProseMirror ul,\n.ProseMirror ol {\n  margin: 0;\n  padding-left: 1.25rem;\n}\n\n.ProseMirror li {\n  margin: 0;\n}\n\n.ProseMirror h1,\n.ProseMirror h2,\n.ProseMirror h3 {\n  margin: 0.25rem 0;\n}\n\n\n[data-resize-handle] {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  background-color: #0d6efd; /* Blue handle color */\n  border: 2px solid white;\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 10;\n}\n\n/* Position handles for corners/edges (Tiptap applies these data attributes) */\n[data-resize-handle=\"top-left\"] { top: -5px; left: -5px; cursor: nwse-resize; }\n[data-resize-handle=\"top-right\"] { top: -5px; right: -5px; cursor: nesw-resize; }\n[data-resize-handle=\"bottom-left\"] { bottom: -5px; left: -5px; cursor: nesw-resize; }\n[data-resize-handle=\"bottom-right\"] { bottom: -5px; right: -5px; cursor: nwse-resize; }\n[data-resize-handle=\"left\"] { left: -5px; top: 50%; transform: translateY(-50%); cursor: ew-resize; width: 10px; height: 20px; }\n[data-resize-handle=\"right\"] { right: -5px; top: 50%; transform: translateY(-50%); cursor: ew-resize; width: 10px; height: 20px; }\n[data-resize-handle=\"top\"] { top: -5px; left: 50%; transform: translateX(-50%); cursor: ns-resize; width: 20px; height: 10px; }\n[data-resize-handle=\"bottom\"] { bottom: -5px; left: 50%; transform: translateX(-50%); cursor: ns-resize; width: 20px; height: 10px; }\n\n/* Optional: Style during active resize */\n.is-resizing {\n  opacity: 0.8;\n  cursor: grabbing;\n}\n\n/* Ensure the resizable container doesn't interfere */\n.tiptap-resizable {\n  position: relative;\n  display: inline-block;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
